import React from 'react'

const SmallImage = (props: any) => (
  <img src={props.src} alt={props.src} className="h-64" />
)

export default SmallImage
